<template>
  <div class="request-comic-page">
    <h2 class="page-title">您想看的漫画将在一周内给到您回复</h2>
    <!-- 留言输入框 -->
    <div class="leave-message">
      <textarea
        v-model="newMessage"
        class="message-input"
        placeholder="请输入您想要找到的漫画..."
      ></textarea>
      <button @click="submitMessage" class="submit-button">提交</button>
    </div>
    <!-- 留言列表 -->
    <!-- 其中 show-login-popup 冒泡到 App.vue -->
    <div class="message-list">
      <MessageItem
        v-for="message in messages"
        :key="message.messageId"
        :message="message"
        @show-login-popup="$emit('show-login-popup')"
        @show-popup-message="showPopupMessage"
        @message-deleted="onGuestbookMessageDeleted"
      />
    </div>

    <!-- 分页组件 -->
    <div class="comment-pagination" v-if="total > 0 && totalPages > 0">
      <Pagination
        :key="`message-pagination-${totalPages}-${currentPage}`"
        :total-pages="totalPages"
        :current-page="currentPage"
        :total-count="total"
        :page-size="pageSize"
        :show-page-size-selector="false"
        :show-jump-to-page="false"
        unit="条"
        @change-page="handleMessagePageChange"
      />
    </div>
    <!-- 无留言提示 -->
    <div class="no-comments" v-if="messages.length === 0 && !loading">
      <p>暂无留言，快来发表第一条留言吧！</p>
    </div>
  </div>
</template>

<script setup>
import MessageItem from '@/features/message/components/MessageItem.vue'
import Pagination from '@/shared/components/Pagination.vue'
import { useRequestComicPage } from '@/features/comic/composables/useRequestComicPage'

const emit = defineEmits(['show-popup-message', 'show-login-popup'])

const {
  newMessage,
  messages,
  currentPage,
  totalPages,
  total,
  pageSize,
  loading,
  submitMessage,
  handleMessagePageChange,
  showPopupMessage,
  onGuestbookMessageDeleted,
} = useRequestComicPage(emit)
</script>

<style scoped src="@/features/comic/styles/RequestComic.css"></style>
